import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.element.addEventListener("form:reinitialize", this.handleReinitialize.bind(this))
        this.element.addEventListener("turbo:submit-start", this.submitStart.bind(this))
        this.element.addEventListener("turbo:submit-end", this.submitEnd.bind(this))
        this.defaultInnerHtml = null
    }

    disconnect() {
        this.element.removeEventListener("form:reinitialize", this.handleReinitialize)
        this.element.removeEventListener("turbo:submit-start", this.submitStart)
        this.element.removeEventListener("turbo:submit-end", this.submitEnd)
    }

    submitStart = (e) => {
        e.preventDefault()
        this.defaultInnerHtml = e?.detail?.formSubmission?.submitter?.innerHTML
        this.disableButton(e, true)
    }

    submitEnd = (e) => {
        e.preventDefault()

        const submitter = e?.detail?.formSubmission?.submitter
        const rspStatus = e?.detail?.fetchResponse?.response?.status
        const rspHeaders = e?.detail?.fetchResponse?.response?.headers

        const headerEvent = rspHeaders?.get('Event');

        if (headerEvent) {
            const headerEventPayload = JSON.parse(rspHeaders.get('Event-Payload'))
            const event = new CustomEvent(headerEvent, {detail: headerEventPayload})
            document.dispatchEvent(event)
        }

        if (submitter === undefined) {
            return;
        }

        if (rspStatus >= 500) {
            submitter.disabled = true
            submitter.innerHTML = 'error'
            submitter.classList.add('disabled')
        } else if (rspStatus === 200) {
            submitter.innerHTML = this.defaultInnerHtml;
            this.disableButton(e, false)
        } else if (rspStatus === 204) {
            this.disableButton(e, true)
        }


    }

    submit(e) {
        this.element.requestSubmit()
    }

    handleReinitialize(e) {
        this.reinitializeForm(e)
    }

    reinitializeForm(e) {
        const input = e.target;
        const form = input.form || input
        const outerTurboFrame = form.closest('turbo-frame[src]')
        const innerTurboFrame = form.closest('turbo-frame')
        const formData = new FormData(form);
        let queryString = new URLSearchParams(formData).toString();
        innerTurboFrame.src = ((outerTurboFrame?.src.split("?")[0] || window.location.href)) + `?${queryString}`
    }
    
    disableButton(e, disabled) {
        const submitter = e?.detail?.formSubmission?.submitter
        const submitterTagName = submitter?.tagName
        const disabledText = '<i class="fa-solid fa-rotate animate-spin" aria-hidden="true"></i>';

        if (submitter === undefined) {
            return;
        }

        submitter.disabled = disabled
        if (disabled) {
            submitter.classList.add("disabled")
            submitter.form.classList.add("pointer-events-none")
        } else {
            submitter.classList.remove("disabled")
            submitter.form.classList.remove("pointer-events-none")
        }

        if (disabled) {
            submitter.innerHTML = disabledText
        }
    }


}